// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/admin_user.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * AdminUser構造体
 *
 * @generated from message entity.AdminUser
 */
export class AdminUser extends Message<AdminUser> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string mail = 2;
   */
  mail = "";

  /**
   * @generated from field: string admin_name = 3 [json_name = "admin_name"];
   */
  adminName = "";

  /**
   * @generated from field: string password_hash = 4 [json_name = "password_hash"];
   */
  passwordHash = "";

  /**
   * @generated from field: bool is_first_login = 5 [json_name = "is_first_login"];
   */
  isFirstLogin = false;

  /**
   * @generated from field: google.protobuf.Timestamp last_login_date = 6 [json_name = "last_login_date"];
   */
  lastLoginDate?: Timestamp;

  /**
   * @generated from field: bool is_debug_user = 7 [json_name = "is_debug_user"];
   */
  isDebugUser = false;

  /**
   * @generated from field: entity.AdminUserTime user_time = 8 [json_name = "user_time"];
   */
  userTime?: AdminUserTime;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string environment = 10;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 11 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 12 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 13;
   */
  version = "";

  constructor(data?: PartialMessage<AdminUser>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.AdminUser";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "admin_name", jsonName: "admin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password_hash", jsonName: "password_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_first_login", jsonName: "is_first_login", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "last_login_date", jsonName: "last_login_date", kind: "message", T: Timestamp },
    { no: 7, name: "is_debug_user", jsonName: "is_debug_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "user_time", jsonName: "user_time", kind: "message", T: AdminUserTime },
    { no: 9, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 12, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 13, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUser {
    return new AdminUser().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUser {
    return new AdminUser().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUser {
    return new AdminUser().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUser | PlainMessage<AdminUser> | undefined, b: AdminUser | PlainMessage<AdminUser> | undefined): boolean {
    return proto3.util.equals(AdminUser, a, b);
  }
}

/**
 *
 *
 * @generated from message entity.AdminUserTime
 */
export class AdminUserTime extends Message<AdminUserTime> {
  /**
   * 固定日時（設定されている場合、Now()はこの時刻を返す）
   *
   * @generated from field: google.protobuf.Timestamp fixed_date = 1 [json_name = "fixed_date"];
   */
  fixedDate?: Timestamp;

  constructor(data?: PartialMessage<AdminUserTime>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.AdminUserTime";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fixed_date", jsonName: "fixed_date", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUserTime {
    return new AdminUserTime().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUserTime {
    return new AdminUserTime().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUserTime {
    return new AdminUserTime().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUserTime | PlainMessage<AdminUserTime> | undefined, b: AdminUserTime | PlainMessage<AdminUserTime> | undefined): boolean {
    return proto3.util.equals(AdminUserTime, a, b);
  }
}

